export default __webpack_public_path__ + "static/KawkabMono-Regular-750e6d7626fa6c0f815e3a3c0fd9d88c.ttf";